<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="池组名称：">
        <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" @keyup.enter.native="getOldToNewListHandler"
          clearable></el-input>
      </el-form-item>
      <el-form-item label="代理商名称：">
        <el-input v-model.trim="searchForm.agentName" placeholder="支持模糊搜索" @keyup.enter.native="getOldToNewListHandler"
          clearable></el-input>
      </el-form-item>

      <el-form-item label="供应商：" prop="">
        <el-select v-model="searchForm.supplierId" filterable>
          <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
            :label="`${item.name + ' ( ' + item.alias + ' )'}`"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="余额低于：">
        <el-input v-model.trim="searchForm.amount" placeholder="池组余额低于多少元" @keyup.enter.native="getOldToNewListHandler"
          clearable></el-input>
      </el-form-item> -->
      <el-form-item class="btnArea">
        <el-button type="primary" @click="getOldToNewListHandler" plain icon="el-icon-search">搜索查询</el-button>
        <el-button type="success" plain icon="el-icon-download" @click="addStore()">新增池组</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tbpg.tableData" border>
      <el-table-column prop="name" label="池组名称" width="160" align="center"></el-table-column>
      <el-table-column prop="supplierName" label="供应商" align="center"></el-table-column>
      <el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
      <el-table-column prop="price" label="单价（元）" align="center"></el-table-column>
      <!-- <el-table-column prop="amountLog" label="充值总额（元）" align="center"></el-table-column> -->
      <!-- <el-table-column prop="amount" label="余额（元）" align="center"></el-table-column> -->
      <el-table-column prop="poolYa" label="保证金" align="center"></el-table-column>
      <!-- <el-table-column prop="typeName" label="超套操作" align="center"></el-table-column> -->
      <el-table-column prop="totalSim" label="总卡数" align="center"></el-table-column>
      <el-table-column prop="activeSim" label="总激活数" align="center"></el-table-column>
      <el-table-column prop="activingSim" label="月激活数" align="center"></el-table-column>
      <el-table-column prop="monthUse" label="使用流量（G）" width="110" align="center"></el-table-column>
      <el-table-column prop="monthPrice" label="产生费用（元）" width="110" align="center"></el-table-column>
      <el-table-column prop="dayUse" label="日均流量（G）" width="110" align="center"></el-table-column>
      <el-table-column prop="minUse" label="抵消（G）" align="center"></el-table-column>
      <el-table-column prop="minPrice" label="最低消费（元）" width="110" align="center"></el-table-column>
      <el-table-column prop="stopPrice" label="保号费（元）" width="120" align="center"></el-table-column>
      <!-- <el-table-column align="center" label="卡备注" width="100px">
        <template v-slot="scope">
          <el-tooltip :content="scope.row.remark">
            <p style="color:crimson"> {{ scope.row.remark }}</p>
          </el-tooltip>
        </template>
</el-table-column> -->
      <el-table-column prop="createTime" label="时间" width="160" align="center"></el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-dropdown>
            <el-button type="success">
              池组操作
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="dataEdit(scope.row)"
                style="color:black;font-weight :bold;">编辑池组</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="updateYu(scope.row)"
                style="color:black;font-weight :bold;">余额管理</el-dropdown-item> -->
              <el-dropdown-item @click.native="selectYu(scope.row)"
                style="color:black;font-weight :bold;">余额流水</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="exportApplyHandler(scope.row)"
                style="color:black;font-weight :bold;">导出卡板</el-dropdown-item> -->
              <el-dropdown-item @click.native="deletePool(scope.row.id)"
                style="color:red;font-weight :bold;">删除池组</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="toNewCardVisible" width="1200px"
      :close-on-click-modal="false" @close="cancel">
      <el-form ref="toNewCardForm" :rules="rules" :model="toNewCardForm" label-width="120px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="池组名称：" prop="name">
              <el-input v-model="toNewCardForm.name" placeholder="请输入池组名称" @input="change($event)"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="单价/元：" prop="price">
              <el-input v-model="toNewCardForm.price" placeholder="请输入流量单价多少元/GB" @input="change($event)"></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="停机保号费：" prop="stopPrice">
              <el-input v-model="toNewCardForm.stopPrice" placeholder="（选填）单位/元" @input="change($event)"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="已收保证金：" prop="poolYa">
              <el-input v-model="toNewCardForm.poolYa" placeholder="（选填）池组已抵押的保证金。单位/元"
                @input="change($event)"></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="低消类型：" prop="poolType">
              <el-select v-model="toNewCardForm.poolType" clearable @input="change($event)" readonly>
                <el-option v-for="(item, index) in poolTypeList" :key="index" :label="item.label"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="toNewCardForm.poolType == 1 || toNewCardForm.poolType == 2">
            <el-form-item label="抵消/GB：" prop="minUse">
              <el-input v-model="toNewCardForm.minUse" placeholder="（选填）抵消G数" @input="change($event)"></el-input>
            </el-form-item>
          </el-col>


          <el-col :span="12" v-if="toNewCardForm.poolType == 2">
            <el-form-item label="扩池流量/GB：" prop="outAddData">
              <el-input v-model="toNewCardForm.outAddData" placeholder="当流量超套时，一次性扩池流量/GB" @input="change($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="toNewCardForm.poolType == 2">
            <el-form-item label="结余方式：" prop="outAddType">
              <el-select v-model="toNewCardForm.outAddType" clearable @input="change($event)"  placeholder="当月结日 扩池流量大于总使用量时，处理方式">
                <el-option v-for="(item, index) in addTypeList" :key="index" :label="item.label"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属代理：" prop="agentId">
              <el-select v-model="toNewCardForm.agentId" @input="change($event)" filterable>
                <el-option v-for="(item, index) in agentListOption" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>



          <el-col :span="12">
            <el-form-item label="所属供应商：" prop="supplierId">
              <el-select v-model="toNewCardForm.supplierId" @input="change($event)" filterable>
                <el-option v-for="(item, index) in branchSupplierOption" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>



<!-- 
          <el-col :span="12">
            <el-form-item label="激活扣除费用：" prop="activePrice">
              <el-input v-model="toNewCardForm.activePrice" placeholder="（选填）激活格外扣除费用，如功能费，自定义其它费用等。 单位/元"
                @input="change($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="激活扣费类型：" prop="activeType">
              <el-select v-model="toNewCardForm.activeType" clearable @input="change($event)"
                placeholder="（选填）激活扣除一次 / 每月激活都扣">
                <el-option v-for="(item, index) in activeTypeList" :key="index" :label="item.label"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="12">
            <el-form-item label="超套操作：" prop="type">
              <el-select v-model="toNewCardForm.type" clearable @input="change($event)">
                <el-option v-for="(item, index) in storeStateList" :key="index" :label="item.label"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="12">
            <el-form-item label="剩余余额告警：" prop="warnYu">
              <el-input v-model="toNewCardForm.warnYu" placeholder="（选填）当余额低于多少元时，发送短信通知"
                @input="change($event)"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="告警手机号：" prop="warnPhone">
              <el-input v-model="toNewCardForm.warnPhone" placeholder="（选填）多个手机号以-隔开 如1588886666-166888888"
                @input="change($event)"></el-input>
            </el-form-item>
          </el-col> -->

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <p style="color: red;" v-if="!this.toNewCardForm.id">低消类型确定后，后续不可再修改变更。</p>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureToNewCardHandler">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog :append-to-body="true" title="流水记录" :visible.sync="actionLogVisible" width="1000px"
      :close-on-click-modal="false">
      <el-table :data="actionLogTbpg.tableData" border height="421">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="amount" label="交易金额"></el-table-column>
        <el-table-column prop="balance" label="交易余额"></el-table-column>
        <el-table-column prop="typeName" label="交易类型" width="100"></el-table-column>
        <el-table-column prop="remark" label="交易备注"></el-table-column>
        <el-table-column prop="createName" label="系统备注"></el-table-column>
        <el-table-column prop="createTime" label="交易时间" width="140"></el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
        :current-page="actionLogTbpg.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="actionLogTbpg.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="actionLogTbpg.total">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="actionLogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>



    <el-dialog :append-to-body="true" title="池组余额" :visible.sync="amountFlg" width="600px" @close="amountFlg = false"
      :close-on-click-modal="false">
      <el-form ref="amountData" :model="amountData" label-width="120px">

        <el-form-item label="交易类型:">
          <el-radio v-model="amountData.type" label="1">增加</el-radio>
          <el-radio v-model="amountData.type" label="0">扣减</el-radio>
        </el-form-item>
        <el-form-item label="交易金额：" prop="amount">
          <el-input-number v-model="amountData.amount" :precision="2" :step="1" :min="0">
          </el-input-number>
        </el-form-item>

        <el-form-item label="交易备注：">
          <el-input v-model="amountData.remark"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="amountFlg = false">取 消</el-button>
        <el-button type="primary" @click="sureUpdate()">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error('代理商手机号有误，请重新输入。'))
      } else {
        callback()
      }
    }
    return {
      amountData: {
        id: '',
        amount: '',
        type: '',
        remark: ''
      },
      amountFlg: false,


      actionLogVisible: false,
      actionLogTbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0
      },



      agentListOption: [],
      searchForm: {
        name: "",
        storeType: "",
        // moveIds: [],
      },
      moveIdsList: [],
      storeStateList: [
        { label: '暂不操作', id: '0' },
        { label: '关停接口', id: '1' },
        { label: '卡板停机', id: '2' }],


      poolTypeList: [
        { label: '无低消', id: '0' },
        { label: '单卡低消', id: '1' },
        { label: '共享低消', id: '2' }],

      addTypeList: [
        { label: '系统自动结余次月', id: '0' },
        { label: '人工手动结余', id: '1' }
      ],


      activeTypeList: [
        { label: '卡板首次激活', id: '0' },
        { label: '每月首次激活', id: '1' }
      ],
      title: '',
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      rules: {
        name: [
          { required: true, message: '店铺名称不能为空', trigger: ['blur', 'change'] }
        ],
        type: [
          { required: true, message: '超套设置', trigger: ['blur', 'change'] }
        ],
        agentId: [
          { required: true, message: '代理商不能为空', trigger: ['blur', 'change'] }
        ],
        price: [
          { required: true, message: '单价不能为空', trigger: ['blur', 'change'] }
        ],
        supplierId: [
          { required: true, message: '供应商不能为空', trigger: ['blur', 'change'] }
        ],
        poolType: [
          { required: true, message: '低消类型不能为空', trigger: ['blur', 'change'] }
        ],

      },
      branchSupplierOption: [],
      toNewCardVisible: false, //显示新增编辑弹窗
      toNewCardForm: {
        id: '',
        name: '',
        type: '0',
        activePrice: '',
        supplierId: '',
        agentId: '',
        price: '',
        poolYa: '',
        poolType: '',
        minUse: '',
        stopPrice: '',
        outAddType: '',
        outAddData: '',
        warnPhone:'',
        warnYu:''
      },
      selectInfoId: '',
    };
  },
  created() {
    common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
    common.getAgentListOptionCom(this, 'agentListOption');
    this.getOldToNewListHandler();
  },
  methods: {
    handleSizeChanges(val) {
      this.actionLogTbpg.pageSize = val;
      this.selectYu();
    },
    handleCurrentChanges(val) {
      this.actionLogTbpg.currentPage = val
      this.selectYu();
    },


    exportApplyHandler(row) {
      var data = {
        id: row.id
      }
      this.$confirm('确定导出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        common.sysRequest('export/poolSim', data, 'post').then(res => {
          if (res.data.code == 200) {
            this.$message.success('数据导出中,请稍候去任务中心下载');
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }).catch(() => {

      });
    },

    updateYu(row) {
      this.amountData.id = row.id;
      this.amountData.type = '';
      this.amountData.amount = '';
      this.amountData.remark = '';
      this.amountFlg = true;
    },
    sureUpdate() {
      common.sysRequest('pool/update/amount/info', this.amountData, 'post').then(res => {
        if (res.data.code == 200) {
          this.$message.success("操作成功！")
          this.amountFlg = false;
          this.getOldToNewListHandler();
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    selectYu(row, $event) {
      if (row && row.id) {
        this.selectInfoId = row.id;
      }
      common.resetCurrentPage(this, $event, 'actionLogTbpg');
      let data = common.getRequestParams(this, 'actionLogTbpg', { id: this.selectInfoId });
      common.sysRequest('pool/select/amount/info', data, 'post').then(res => {
        common.listCallback(this, res, 'actionLogTbpg');
        this.actionLogVisible = true;
      })
    },
    deletePool(id) {
      this.$confirm("删除后，数据会全部清空且无法恢复！您确定要进行删除操作吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var data = {
          id: id
        }
        common.sysRequest('pool/delete/task', data, 'post').then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功！")
            this.getOldToNewListHandler();
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    cancel() {
      this.toNewCardForm = {};
      this.$refs['toNewCardForm'].resetFields();
      this.toNewCardVisible = false;
      this.$forceUpdate()
    },
    getOldToNewListHandler($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      common.sysRequest('pool//select/all/task/page', data, 'post').then(res => {
        common.listCallback(this, res, 'tbpg');
      })
    },


    addStore() {
      this.toNewCardVisible = true;
      this.toNewCardForm.id = ''
      this.title = '新增池组'
      this.$forceUpdate()
    },
    sureToNewCardHandler() {
      this.$refs['toNewCardForm'].validate((valid) => {
        if (valid) {
          if (this.toNewCardForm.id) {
            common.sysRequest('pool/update/task', this.toNewCardForm, 'post').then(res => {
              if (res.data.code == '200') {
                this.cancel();
                this.getOldToNewListHandler();
                this.$message({ message: res.data.message, type: 'success', duration: 4000 })
              } else {
                this.$message({ message: res.data.message, type: 'error', duration: 4000 })
              }
            })
          } else {
            common.sysRequest('pool/add/task', this.toNewCardForm, 'post').then(res => {
              if (res.data.code == '200') {
                this.cancel();
                this.getOldToNewListHandler();
                this.$message({ message: res.data.message, type: 'success', duration: 4000 })
              } else {
                this.$message({ message: res.data.message, type: 'error', duration: 4000 })
              }
            })
          }
        }
      })
    },
    dataEdit(data) {
      this.title = '编辑池组'
      this.toNewCardForm = data
      this.toNewCardForm.type = data.type;
      this.toNewCardVisible = true;
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getOldToNewListHandler();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getOldToNewListHandler();
    },
    change(e) {
      this.$forceUpdate()
    },
    addressChange(arr) {

    },

  }
};
</script>

<style lang="less" scoped></style>
